/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import { UserState } from '../../../interfaces';

export enum LoginTypes {
  SIGN_IN_REQUEST = '@login/SIGN_IN_REQUEST',
  SIGN_IN_SUCCCES = '@login/SIGN_IN_SUCCCES',
  SIGN_IN_FAILURE = '@login/SIGN_IN_FAILURE',
  LOGOUT = '@login/LOGOUT',
}

export interface LoginState {
  readonly login: string;
  readonly token: string;
  readonly errorMessage: string;
  readonly isError: boolean;
  readonly signed: boolean;
  readonly loading: boolean;
  readonly password: string;
  readonly avatar: string;
  readonly name: string;
  readonly permissoes: Array<string>;
}

export const SET_USER = 'SET_USER';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_IS_ERROR = 'SET_IS_ERROR';
export const SET_LOADING_LOGIN = 'SET_LOADING_LOGIN';
export const SET_CLEAN_USER = 'SET_CLEAN_USER';

interface SetUser {
  type: typeof SET_USER;
  payload: UserState;
}

interface SetCleanUser {
  type: typeof SET_CLEAN_USER;
}

interface SetLoadingLogin {
  type: typeof SET_LOADING_LOGIN;
  payload: boolean;
}

interface SetLoginErrorMessageLogin {
  type: typeof SET_ERROR_MESSAGE;
  payload: string;
}
interface SetLoginIsErrorMessageLogin {
  type: typeof SET_IS_ERROR;
  payload: boolean;
}

export type UserActionTypes =
  | SetUser
  | SetLoginErrorMessageLogin
  | SetLoginIsErrorMessageLogin
  | SetLoadingLogin
  | SetCleanUser
